<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        {{ title }} Failure Notification
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0" />

<mat-dialog-content>
    <form [formGroup]="form">
        <div class="flex justify-end my-2" *ngIf="params.payload.status">
            <span [ngClass]="{
                    'py-1 px-7': true,
                    'idleBadge': params.payload.status == status.DRAFT,
                    'successBadge': params.payload.status == status.APPROVED,
                    'failedBadge': params.payload.status == status.REJECTED,
                    'warningBadge': params.payload.status == status.READY
                }">
                {{ params.payload.status ?? "-" }}
            </span>
        </div>
        <div class="grid grid-cols-3 gap-2 my-2">
            <mat-form-field class="w-full custom-mat-form-field mx-2" floatLabel="always">
                <mat-label>Well String</mat-label>
                <input type="text" placeholder="Enter Well String Name" matInput formControlName="stringShortName"
                    [matAutocomplete]="stringName" (blur)="validateWellStringSelection()" #autoInput />
                <!-- Suffix Icon -->
                <button mat-icon-button matSuffix>
                    <mat-icon svgIcon="mat_solid:arrow_drop_down" style="color: #757575;"></mat-icon>
                </button>

                <mat-autocomplete #stringName="matAutocomplete">
                    <mat-option *ngFor="let row of options.wellStrings" [value]="row.stringShortName"
                        [disabled]=" row.stringShortName == 'Not Found'">
                        {{ row.stringShortName }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="form.get('stringShortName')?.hasError('required')">Well String is required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Well Healthiness</mat-label>
                <mat-select matNativeControl formControlName="isWellHealthy">
                    <mat-option [value]="true">Healthy</mat-option>
                    <mat-option [value]="false">Unhealthy</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('isWellHealthy')?.hasError('required')">Well Healthiness is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Risk Ranking</mat-label>
                <mat-select matNativeControl formControlName="riskRanking">
                    <ng-container *ngIf="form.get('isWellHealthy')?.value">
                        <mat-option [value]="0">Healthy no risk</mat-option>
                        <mat-option [value]="1">Healthy low risk</mat-option>
                        <mat-option [value]="2">Healthy medium risk</mat-option>
                    </ng-container>

                    <ng-container *ngIf="!form.get('isWellHealthy')?.value">
                        <mat-option [value]="3">Unhealthy high risk</mat-option>
                        <mat-option [value]="4">Unhealthy very high risk</mat-option>
                    </ng-container>
                </mat-select>
                <mat-error *ngIf="form.get('riskRanking')?.hasError('required')">Risk Ranking is required</mat-error>
            </mat-form-field>
        </div>

        <hr />
        <div class="grid grid-cols-2 gap-2 my-2">
            <mat-form-field class="w-full custom-mat-form-field mx-2" floatLabel="always">
                <mat-label>Failed Equipment</mat-label>
                <mat-select matNativeControl formControlName="failEquipment">
                    <mat-option *ngFor="let row of options.filteredValveOptions" [value]="row.name">
                        {{ row.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('failEquipment')?.hasError('required')">Failed Equipment is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Failure Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="failureDate" readonly />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="form.get('failureDate')?.hasError('required')">Failure Date is required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Reported Problem</mat-label>
                <input type="text" matInput formControlName="problemReported" />
                <mat-error *ngIf="form.get('problemReported')?.hasError('required')">Reported Problem is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field class="col-start-1 col-span-2 w-full custom-mat-form-field mx-2">
                <mat-label>Detail Description</mat-label>
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10"
                    formControlName="detailDesc"></textarea>
                <mat-error *ngIf="form.get('detailDesc')?.hasError('required')">Detail Description is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field class="col-start-1 col-span-2 w-full custom-mat-form-field mx-2">
                <mat-label>Forward Action Plan</mat-label>
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10"
                    formControlName="forwardActionPlan"></textarea>
                <mat-error *ngIf="form.get('forwardActionPlan')?.hasError('required')">Forward Action Plan is
                    required</mat-error>
            </mat-form-field>
        </div>

        <hr />
        <div class="grid grid-cols-2 gap-2 my-2">
            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Prepared by</mat-label>
                <input type="text" matInput formControlName="preparedBy" />
            </mat-form-field>
            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Approved by</mat-label>
                <input type="text" matInput formControlName="approvedBy" />
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button [matMenuTriggerFor]="menu" class="btn btn-outline" *ngIf="isDisabledSave" [disabled]="disabledSubmit()">
        Save
        <mat-icon>
            <mat-icon class="text-primary">expand_less</mat-icon>
        </mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <ng-container *ngIf='params.payload.status != status.READY'>
       
            <button mat-menu-item (click)="save(status.DRAFT)">
                <span>Save as Draft</span>
            </button>

            <button mat-menu-item (click)="save(status.READY)">
                <span>Submit for Review</span>
            </button>
        </ng-container>

        <ng-container *ngIf='params.payload.status == status.READY'>
            <button mat-menu-item (click)="save()">
                <span>Save</span>
            </button>
            <button mat-menu-item (click)="save(status.APPROVED)">
                <span>Approve</span>
            </button>
            <button mat-menu-item (click)="save(status.REJECTED)">
                <span>Reject</span>
            </button>
        </ng-container>


    </mat-menu>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>